module.exports = __webpack_public_path__ + "img/logo-500.30c6f3f4.png";